import React, {
  Dispatch,
  ReactElement,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'

import { FormOutlined } from '@ant-design/icons'
import { Col, Row, Skeleton, Table } from 'antd'
import ID_COMPONENTE from 'config/idComponente'
import { IAlertaOcorrencia, IHorario } from 'Models/docas'
import WsDocasService from 'Services/WS_DOCAS'

interface IProps {
  horario: IHorario
  setCdAlertaOcorrencia: Dispatch<SetStateAction<number>>
  setNomeAlerta: Dispatch<SetStateAction<string>>
  setJustificarAlerta: Dispatch<SetStateAction<boolean>>
  setJustificativaAnterior: Dispatch<SetStateAction<string | undefined>>
}

const ModalVisualizacaoAlertas = ({
  horario,
  setCdAlertaOcorrencia,
  setNomeAlerta,
  setJustificarAlerta,
  setJustificativaAnterior,
}: IProps): ReactElement => {
  const [alertas, setAlertas] = useState<IAlertaOcorrencia[]>([])
  const [carregandoAlertas, setCarregandoAlertas] = useState<boolean>(true)

  useEffect(() => {
    getAlertas()
  }, [])

  const getAlertas = async () => {
    const { data } = await WsDocasService.alerta.getList(
      ID_COMPONENTE.DOCAS,
      horario.cdAgendamentoDocasHorario,
    )

    if (data.items) {
      setAlertas(data.items)
    }

    setCarregandoAlertas(false)
  }

  const justificaAlerta = (cdAlertaOcorrencia: number) => {
    setCdAlertaOcorrencia(cdAlertaOcorrencia)

    const alerta = alertas.find(
      (f) => f.cdAlertaOcorrencia == cdAlertaOcorrencia,
    )

    if (alerta) {
      setNomeAlerta(alerta.nome)

      if (alerta.justificativa) {
        setJustificativaAnterior(alerta.justificativa)
      }
    }

    setJustificarAlerta(true)
  }

  return (
    <Skeleton loading={carregandoAlertas} active>
      <Row>
        <Col span={24}>
          <Table
            size="small"
            pagination={false}
            scroll={{ y: 240 }}
            columns={[
              {
                title: '',
                key: 'cdAlertaOcorrencia',
                dataIndex: 'cdAlertaOcorrencia',
                width: '25px',
                render: (cdAlertaOcorrencia: number) => (
                  <div
                    style={{ cursor: 'pointer' }}
                    title="Justificar"
                    onClick={() => justificaAlerta(cdAlertaOcorrencia)}
                  >
                    <FormOutlined />
                  </div>
                ),
              },
              {
                title: 'Nome',
                key: 'nome',
                dataIndex: 'nome',
                width: '230px',
              },
              {
                title: 'Data de Abertura',
                key: 'dtAbertura',
                dataIndex: 'dtAbertura',
                width: '145px',
              },
              {
                title: 'Data de Fechamento',
                key: 'dtFechamento',
                dataIndex: 'dtFechamento',
                width: '150px',
              },
              {
                title: 'Justificativa',
                key: 'justificativa',
                dataIndex: 'justificativa',
                width: '250px',
              },
              {
                title: 'Justificado Por',
                key: 'usuarioJustificativa',
                dataIndex: 'usuarioJustificativa',
              },
            ]}
            dataSource={alertas}
          />
        </Col>
      </Row>
    </Skeleton>
  )
}

export default ModalVisualizacaoAlertas
